import { memo } from 'react';
import { SearchProductResult } from '../../types/index';
import { checkStores } from '../../../../../../utility/utility';

const SuggestionProductsResults = ({
  productResults,
  clickSuggestedTerm,
}: {
  productResults: SearchProductResult[];
  clickSuggestedTerm: (type: string) => void;
}) => {
  return (
    <>
      {productResults.map((product: SearchProductResult) => {
        return (
          <div
            key={`product-results-${product.productId}`}
            className="dsg-search-suggestion-result-container">
            <a
              className="dsg-search-suggestion-result hmf-text-align-left hmf-body-l hmf-body-m-m"
              href={checkStores(
                `${product.seoUrl}${
                  product.seoUrl?.includes('Product=ProductSuggest')
                    ? ''
                    : '?Product=ProductSuggest'
                }`,
              )}
              onClick={() => clickSuggestedTerm('products')}>
              <span>{product.name}</span>
            </a>
          </div>
        );
      })}
    </>
  );
};

export default memo(
  SuggestionProductsResults,
  (prev, next) => prev.productResults === next.productResults,
);
